module.exports = __webpack_public_path__ + "static/media/acepta_pie.2c9fcede.svg";